import VendaService from "@/services/VendaService";
import { router } from "@/router";
import Helper from "@/helper";
import lodash from "lodash";
import store from "@/store";

export const actions = {
  cadastrarVenda: ({ commit }) => {
    commit("setVenda", {
      id: null,
      status: "",
      subtotal: "0,00",
      desconto: "0,00",
      desconto_percentual: "0,00",
      total: "0,00",
      valor_pago: "0,00",
      troco: "0,00",
      cliente_id: "",
      formas_pagamento: [],
      cpf: "",
      cfop: "",
      valor_frete: 0,
      chave_nfe: "",
      numero_nfe: "",
      estado_nfe: "",
      path_xml: "",
      acrescimo: 0,
      saldo_troca: "0,00",
    });
    commit("setProdutoVenda", {});
    commit("setProdutosVenda", []);
    commit("setClienteVenda", {
      id: 1,
      nome: "CONSUMIDOR",
    });
    commit("setContato", {});
  },
  listarVenda: ({ commit }, data) => {
    commit("setOverlay", true);
    VendaService.listar(data)
      .then((res) => {
        if (data.content == "json") {
          commit("setVendas", res.data);
        } else if (data.content == "pdf") {
          commit("setModalPrint", res.data.pdf_link);
        }

        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  async salvarVenda({ commit, dispatch }, data) {
    commit("setOverlay", true);

    await VendaService.salvar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setVenda", res.data);
        commit("snackbarSuccess", "Venda registrada.");
        dispatch("setModalVisualizarVenda", true);
        commit("setTotalVendaComDescontoAdicional", "0,00");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao registrar venda.");
      });
  },
  async atualizarVenda({ commit, dispatch }, data) {
    commit("setOverlay", true);
    console.log("payload actions atualizar venda", data);
    await VendaService.atualizar(data)
      .then((res) => {
        commit("snackbarSuccess", "Venda atualizada.");
        commit("setVenda", res.data);
        commit("setOverlay", false);
        dispatch("setModalVisualizarVenda", true);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar venda.");
      });
  },
  // visualizarVenda: ({ commit, dispatch }, data) => {
  //   commit('setOverlay', true)
  //   VendaService.editar(data.id)
  //   .then(res => {
  //     // console.log('visualizando venda', res.data)
  //     commit('setOverlay', false)
  //     commit('setVenda', {...res.data})
  //     dispatch('setModalVisualizarVenda', true)
  //   })
  //   .catch(e => {
  //     commit('setOverlay', false)
  //     console.log(e)
  //   })
  //   dispatch("setModalVisualizarVenda", true);
  // },
  visualizarVenda: ({ commit, dispatch }, data) => {
    commit('setOverlay', true)
    VendaService.editar(data.id)
    .then(res => {
        commit('setOverlay', false)
        commit("setVenda", res.data);
        dispatch("setModalVisualizarVenda", true);
      }).catch(e => { 
        commit('setOverlay', false)
      })
  },
  editarVenda: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    dispatch("setClienteVenda", {});
    commit("setProdutosVenda", []);

    VendaService.editar(id)
      .then((res) => {
        res.data.itens.map((o) => {
          dispatch("addProdutoVenda", {
            produto_id: o.produto_id,
            descricao: o.produto.descricao,
            preco: parseFloat(o.preco_venda),
            quantidade: parseFloat(o.quantidade),
            subtotal: parseFloat(o.quantidade * o.preco_venda),
            desconto: parseFloat(o.desconto),
            total: parseFloat(o.total_venda),
          });
        });

        dispatch("setClienteVenda", res.data.cliente);
        commit("setContato", res.data.cliente);
        const venda = {
          id: res.data.id,
          status: "",
          subtotal: Helper.formatReal(parseFloat(res.data.subtotal)),
          desconto: Helper.formatReal(parseFloat(res.data.desconto)),
          total: Helper.formatReal(parseFloat(res.data.subtotal)),
          // acrescimo: Helper.formatReal(parseFloat(res.data.acrescimo)),
          acrescimo: res.data.acrescimo,

          valor_pago: Helper.formatReal(parseFloat(res.data.valor_pago)),
          troco: Helper.formatReal(parseFloat(res.data.troco)),
          cliente_id: res.data.cliente_id,
          formas_pagamento: res.data.formas_pagamento,
          cpf: res.data.cpf,
          cfop: res.data.cfop,
        };

        commit("setVenda", venda);
        commit("setOverlay", false);
        dispatch("setModalVisualizarVenda", false);
        router.push({ name: "vendaEditar", params: { id: venda.id } });
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao carregar venda.");
      });
  },

  excluirVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirVenda", false);
    VendaService.excluir(data)
      .then((res) => {
        commit("setOverlay", false);
        dispatch("listarVenda", {
          limit: 20,
          page: 1,
          excluidas: true,
          content: "json",
        });
        dispatch("setModalVisualizarVenda", false);
        commit("snackbarError", "Venda excluída.");
      })
      .catch((e) => {
        commit("setVenda", false);
        commit("snackbarError", "Erro ao excluir venda.");
      });
  },
  setClienteVenda: ({ commit }, data) => {
    commit("setClienteVenda", data);
  },
  setProdutoVenda: ({ commit }, data) => {
    const produto = {
      preco_venda: Helper.formatReal(parseFloat(data.preco_venda)),
    };
    commit("setProdutoVenda", { ...data, ...produto });
  },
  addProdutoVenda: ({ commit, dispatch, getters }, data) => {
    commit("addProdutoVenda", data);
    getters.getVenda.subtotal = Helper.formatReal(Helper.cleanFormatReal(getters.getVenda.subtotal) + data.total + data.desconto);
    dispatch("aplicaDescontoVenda");
  },
  removeProdutoVenda: ({ commit, dispatch, getters }, item) => {
    getters.getVenda.subtotal = Helper.formatReal(Helper.cleanFormatReal(getters.getVenda.subtotal) - item.subtotal);
    getters.getVenda.total = Helper.formatReal(Helper.cleanFormatReal(getters.getVenda.total) - item.total);
    if(item.desconto){
      getters.getVenda.desconto = Helper.formatReal(Helper.cleanFormatReal(getters.getVenda.desconto) - item.desconto);
    }
    if(item.preco_venda_devolucao){
      getters.getVenda.saldo_troca = Helper.formatReal(Helper.cleanFormatReal(getters.getVenda.saldo_troca) - item.preco_venda_devolucao)
    }
    commit('removeProdutoVenda', item)
    dispatch("aplicaDescontoVenda");
  },
  imprimirVendaCupomNaoFiscal: ({ commit }, id) => {
    commit("setOverlay", true);
    VendaService.imprimirCupomNaoFiscal(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir cupom.");
      });
  },
  setModalExcluirVenda: ({ commit }, status) => {
    commit("setModalExcluirVenda", false);
    setTimeout(() => {
      commit("setModalExcluirVenda", status);
    }, 100);
  },
  setModalImprimirVenda: ({ commit }, status) => {
    commit("setModalImprimirVenda", false);
    setTimeout(() => {
      commit("setModalImprimirVenda", status);
    }, 100);
  },
  setModalVisualizarVenda: ({ commit }, status) => {
    commit("setModalVisualizarVenda", false);
    setTimeout(() => {
      commit("setModalVisualizarVenda", status);
    }, 100);
  },
  setModalDescontoAdicionalVenda: ({ commit }, status) => {
    commit("setModalDescontoAdicionalVenda", false);
    setTimeout(() => {
      commit("setModalDescontoAdicionalVenda", status);
    }, 100);
  },
  aplicaDescontoVenda({ getters }) {
    var aplicaDesconto = lodash.debounce(() => {
     // var desconto_percentual = store.getters.getVenda.desconto_percentual ? Helper.cleanFormatReal(store.getters.getVenda.desconto_percentual) : 0;
     var desconto_real = getters.getVenda.desconto ? Helper.cleanFormatReal(getters.getVenda.desconto) : 0;
      
     let total = Helper.cleanFormatReal(getters.getVenda.subtotal) - desconto_real;
     
     if(getters.getVenda.saldo_troca) {
       let saldo_troca = Helper.cleanFormatReal(getters.getVenda.saldo_troca);
       total -= saldo_troca;
     }

     if (total >= 0) {
       getters.getVenda.total = Helper.formatReal(total);
     } else {
       getters.getVenda.total = "0,00";
     }
    }, 300);

    aplicaDesconto();
  },
  setModalListarVenda: ({ commit }, status) => {
    commit("setModalListarVenda", false);
    setTimeout(() => {
      commit("setModalListarVenda", status);
    }, 100);
  },
  setModalExclusaoVenda: ({ commit }, status) => {
    commit("setModalExclusaoVenda", false);
    setTimeout(() => {
      commit("setModalExclusaoVenda", status);
    }, 100);
  },
  aplicarDescontoAdicionalTotalVenda: ({ commit, dispatch }) => {
    dispatch("setModalDescontoAdicionalVenda", false);
    commit("snackbarSuccess", "Desconto aplicado.");
    store.getters.getVenda.desconto = Helper.formatReal(Helper.cleanFormatReal(store.getters.getVenda.desconto) + Helper.cleanFormatReal(store.getters.getDescontoAdicionalTotalVenda));
    store.getters.getVenda.total = Helper.formatReal(Helper.cleanFormatReal(store.getters.getVenda.total) - Helper.cleanFormatReal(store.getters.getDescontoAdicionalTotalVenda));
  commit("setTotalVendaComDescontoAdicional", "0,00");
    commit("setDescontoAdicionalTotalVenda", "0,00");
  },
  async imprimirCheckListProdutoVenda({ commit }, id) {
    commit("setOverlay", true);
    await VendaService.imprimirChecklistProdutos(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setCheckListProdutoVenda", res.data);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
};

export default {};
